module.exports = __webpack_public_path__ + "static/media/14-d-calendar.3c0d9ff3.jpg";